import React from "react";
import Management from "components/general/Management";
import EnrollTeacher from "./EnrollTeacher";

const UniversityTeachers = () => {
    const layout = [
        [
            { label: "Họ", name: "last_name", type: "input", rules: [{ required: true }] },
            { label: "Tên đệm và tên", name: "first_name", type: "input", rules: [{ required: true }] }
        ],
        [
            {
                label: "Email",
                name: "email",
                type: "input",
                rules: [
                    { required: true, message: "Vui lòng nhập email!" },
                    { type: "email", message: "Email không hợp lệ!" },
                ],
            },
            { label: "Ngày sinh", name: "birthday", type: "date", rules: [{ required: true }] },
        ],
    ];

    const columns = [
        { title: "Username", dataIndex: "username", key: "username" },
        { title: "Tên", dataIndex: "first_name", key: "first_name" },
        { title: "Họ", dataIndex: "last_name", key: "last_name" },
        { title: "Ngày sinh", dataIndex: "birthday", key: "birthday", render: value => value?.format("DD/MM/YYYY")},
        { title: "Email", dataIndex: "email", key: "email" },
    ];

    return (
        <div>
            <h2>Quản Lý Giảng Viên</h2>
            <Management
                layout={layout}
                columns={columns}
                apiPath="/teachers/"
                itemName="giảng viên"
                listMode="table"
                useFrontendPagination={false}
                disableSearch={false}
                excelImportExportOptions={{
                    apiPath: "/teachers/",
                    itemName: "giảng viên",
                    exportFields: ["username", "first_name", "last_name", "email"],
                    expectedCsvType: "teachers",
                }}
                expandable={{
                    expandedRowRender: (record, index, indent, expanded)=>
                                        expanded && <EnrollTeacher teacher={record}/>
                }}
                dateFields={[
                    { field: "birthday", type: "date" }
                ]}
            />
        </div>
    );
};

export default UniversityTeachers;
